export default __webpack_public_path__ + "static/media/prancheta1_13.a31c5b9d.png";